@if (currentMessage$ | async; as message) {
    <span class="fade-effect" [ngStyle]="{ 'animation-duration': timeInterval + 'ms' }">
        {{ message | translate }}
    </span>
}
